import React from 'react';
import { motion } from 'framer-motion';

const ApexLogo = ({ className = "" }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.6, 0.05, 0.01, 0.9] }}
      className={`apex-logo-container ${className}`}
    >
      <motion.img
        src="https://customer-assets.emergentagent.com/job_executive-counsel-2/artifacts/v2mw23tm_ChatGPT%20Image%20Mar%2017%2C%202026%2C%2006_11_49%20PM.png"
        alt="Apex Build Project Management"
        className="apex-logo-img"
        whileHover={{ 
          filter: 'brightness(1.15)',
          scale: 1.02,
          transition: { duration: 0.3 }
        }}
      />
    </motion.div>
  );
};

export default ApexLogo;
